import { render } from "./PhysicalExam.vue?vue&type=template&id=7135f97a"
import script from "./PhysicalExam.vue?vue&type=script&lang=js"
export * from "./PhysicalExam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__